import store from "@/store/store";
import { useToast } from "vue-toastification";

const toast = useToast();

window.addEventListener("DOMContentLoaded", function () {
  // Only set up notifications if user is logged in and has an ID
  if (!store.state.auth.user || !store.state.auth.user.id) {
    console.log("Skipping notification setup - no authenticated user");
    return;
  }

  // Only set up notifications if Echo is available
  if (!window.Echo) {
    console.log("Skipping notification setup - Echo not available");
    return;
  }

  const channel = window.Echo.private(`users.${store.state.auth.user.id}`);

  const events = [
    "NewTemplateAddedEvent",
    "NewTemplatesAddedEvent",
    "TemplateUpdatedEvent",
    "SharedDocumentOpenedEvent",
    "DocumentApprovedEvent",
    "DocumentCommentedEvent",
    "DocumentSignedEvent",
  ];

  channel
    .subscribed(function () {
      const handleNotification = (notification) => {
        toast.success(notification.message);

        const unreadNotificationsNumber = store.state.shared.unreadNotifications || 0;
        store.commit("shared/updateUnreadNotifications", unreadNotificationsNumber + 1);
      };

      for (const event of events) {
        channel.listen(event, (notification) => {
          handleNotification(notification);
        });
      }
    })
    .error(function (error) {
      console.error("Error ", error);
    });
});
